<div #root class="detail-panel">
    <div class="detail-panel__body">
        <div class="row g-2">
            <div class="col-lg-4 col-md-4">
                <small class="text-muted">Información detallada del servicio</small>
                <table>
                    <tr>
                        <th>Viajes entregados:</th>
                        <td>
                            <span style="display: block;" *ngIf="data?.status.toUpperCase() == 'FINALIZADO' || data?.status.toUpperCase() == 'SERVICIO EXITOSO'; else elseTemplate" class="mb-1"><b>Ubicación:</b> {{data?.destination_address}}<br /><b>Estatus:</b>
                                {{data?.status}}</span>
                            <ng-template #elseTemplate>
                                <span style="display: block;" class="mb-1">No hay servicios finalizados</span>
                            </ng-template>
                            <div *ngFor="let item of data?.address_services; let i = index">
                                <span style="display: block;" *ngIf="item?.status.toUpperCase() == 'FINALIZADO' || item?.status.toUpperCase() == 'SERVICIO EXITOSO'" class="mb-1"><b>Ubicación {{toLetter(i+1)}}:</b> {{item?.destination}}<br /><b>Estatus:</b>
                                {{item?.status}}</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>Operador:</th>
                        <td><span>{{ fromDepositList ? data?.service?.driver?.name : data?.driver }}</span></td>
                    </tr>
                    <tr>
                        <th>Auxiliar:</th>
                        <td><span>{{ fromDepositList ? data?.service?.assistant?.name : data?.assistant }}</span></td>
                    </tr>
                    <tr>
                        <th>Dirección:</th>
                        <td><span>{{ data?.destination_address }}</span></td>
                    </tr>
                </table>
            </div>
            <div class="col-lg-4 col-md-4">
                <small class="text-muted">Multidestinos</small>
                <table>
                    <tr>
                        <th>Ubicación:</th>
                        <td><span>{{data?.destination_address}}<br /><b>Estatus:</b> {{data?.status}}</span></td>
                    </tr>
                    <tr *ngFor="let item of data?.address_services; let i = index">
                        <th>Ubicación {{ toLetter(i+1) }}:</th>
                        <td><span>{{item.destination}}<br /><b>Estatus:</b> {{item?.status}}</span></td>
                    </tr>
                    <tr>
                        <th>Salida de patio:</th>
                        <ng-container *ngIf="fromDepositList; else regularDeparture">
                            <td *ngIf="data?.service?.departure_date"><span>{{data?.service?.departure_date | date:'dd/MM/yyyy'}} {{data?.service?.departure_time}}</span></td>
                            <td *ngIf="!data?.service?.departure_date">N/A</td>
                        </ng-container>
                        <ng-template #regularDeparture>
                            <td *ngIf="data?.departure_date"><span>{{data?.departure_date | date:'dd/MM/yyyy'}} {{data?.departure_time}}</span></td>
                            <td *ngIf="!data?.departure_date">N/A</td>
                        </ng-template>
                    </tr>
                </table>
            </div>
            <div class="col-lg-4 col-md-4">
                <small class="text-muted">Notas</small>
                <table *ngIf="data?.notes?.length">
                    <tr>
                        <ul>
                            <li *ngFor="let item of data?.notes">{{ item.note }}</li>
                        </ul>
                    </tr>
                </table>
                <p *ngIf="!data?.notes?.length">No hay notas para este servicio.</p>
                <table *ngIf="!fromDepositList">
                    <tr>
                        <td>
                            <a class="btn btn-outline-primary" [routerLink]="cartaPorteRoute" [queryParams]="cartaPorteQueryParams" [class.disabled]="!canOpenCartaPorte">
                                <img src="assets/img/icons/maintenance/document-attachment.svg" alt="">&nbsp;{{ cartaPorteLabel }}
                            </a>
                            <a class="btn btn-outline-primary disabled" *ngIf="!data?.id">
                                <img src="assets/img/icons/maintenance/document-attachment.svg" alt="">&nbsp;Crear carta porte
                            </a>
                            <a class="btn btn-outline-primary ms-2" routerLink="/service/bill-service" [queryParams]="{ folio: data?.folio, id: data?.id, client: data?.client }" *ngIf="data?.id && !data?.invoice_folio">
                                <img src="assets/img/icons/maintenance/document-attachment.svg" alt="">&nbsp;Facturar Servicio
                            </a>
                            <a class="btn btn-outline-primary ms-2" [routerLink]="['/service/list/folio-' + data?.invoice_folio + '/view']" *ngIf="data?.id && data?.invoice_folio">
                                <img src="assets/img/icons/maintenance/document-attachment.svg" alt="">&nbsp;Ver factura
                            </a>
                            <a class="btn btn-outline-primary ms-2 disabled" *ngIf="!data?.id">
                                <img src="assets/img/icons/maintenance/document-attachment.svg" alt="">&nbsp;Facturar Servicio
                            </a>
                        </td>
                    </tr>
                </table>

                <table *ngIf="!fromDepositList && canDo('Control de gastos', 'Registro de viáticos') && (!data?.has_expense || !data?.expense_validated)">
                    <tr>
                        <td>
                            <a class="btn btn-outline-primary" [class.disabled]="!data?.id"
                                [routerLink]="data?.id ? ['/service/expense-report', data?.id] : null">
                                <img src="assets/img/icons/maintenance/document-attachment.svg" alt="">&nbsp;{{ data?.has_expense ? 'Seguimiento de viáticos' : 'Registro de viáticos' }}
                            </a>
                        </td>
                    </tr>
                </table>

                <!-- Botones específicos para deposit-list -->
                <ng-container *ngIf="fromDepositList && canDo('Control de gastos', 'Registro de viáticos')">
                    <table *ngIf="data?.has_expense && !data?.expense_validated">
                        <tr>
                            <td>
                                <a class="btn btn-outline-primary" [routerLink]="['/service/expense-report', data?.service?.id]" *ngIf="data?.service?.id">
                                    Seguimiento de viáticos
                                </a>
                            </td>
                        </tr>
                    </table>
                    <table *ngIf="!data?.has_expense">
                        <tr>
                            <td class="d-flex gap-2 flex-wrap">
                                <a class="btn btn-outline-primary" [routerLink]="['/service/expense-report', data?.service?.id]" *ngIf="data?.service?.id">
                                    Agregar viático
                                </a>
                            </td>
                        </tr>
                    </table>
                </ng-container>
            </div>
        </div>
    </div>
</div>
